<div class="modal-header">
  <h4 class="modal-title"><span i18n>Pricing rules</span>&nbsp;{{ salaryRules.name }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p class="text-muted mb-4" i18n>
        Pricing rules define additional bonuses and compensation based on collective work agreements. These rules help ensure fair and standardized compensation for different work conditions, shifts, and special circumstances.
      </p>
    </div>
    <div class="col-12">
      <label for="rulesetSelect" class="form-label" i18n>Select ruleset</label>
      <select class="form-select" id="rulesetSelect" [(ngModel)]="selectedRuleset">
        <option *ngFor="let ruleset of salaryRules?.rulesets" [ngValue]="ruleset">
          <ng-container i18n>Starting date:</ng-container> {{ ruleset.start | date:'mediumDate' }}
        </option>
      </select>
    </div>

    <div class="col-12 mt-3" *ngIf="selectedRuleset && selectedRuleset.rules && selectedRuleset.rules.length">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th i18n>Name</th>
              <th i18n>Payment type</th>
              <th i18n>Amount</th>
              <th i18n>Cities</th>
              <th i18n>Time range</th>
              <th i18n>Days of week</th>
              <th i18n>Dates</th>
              <th i18n>Excluded dates</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let rule of selectedRuleset.rules">
              <td>{{ rule | translateField: 'name' }}</td>
              <td>{{ rule.payment_type | i18nSelect: salaryRuleRulesetRuleType }}</td>
              <td>
                <ng-container *ngIf="rule.payment_type === 'amount'">
                  {{ rule.payment | currency: organization.currency }}
                </ng-container>
                <ng-container *ngIf="rule.payment_type === 'percent'">
                  {{ rule.payment | number:'1.2-2' }}%
                </ng-container>
              </td>
              <td>
                {{ rule.city_selector | i18nSelect: citySelectorType }}
                <ng-container *ngIf="rule.cities && rule.cities.length">
                  <div *ngFor="let city of rule.cities">
                    {{ city | translateField: 'name' }}
                  </div>
                </ng-container>
                
              </td>
              <td class="text-nowrap">{{ rule.start_time }} - {{ rule.end_time }}</td>
              <td>{{ getActiveDays(rule) }}</td>
              <td>
                <ng-container *ngIf="rule.dates && rule.dates.length">
                  <div *ngFor="let date of rule.dates">
                    {{ date.date | date:'EE' }} {{ date.date | date:'mediumDate' }}
                    <small *ngIf="date.notes" class="text-muted">({{ date | translateField: 'notes' }})</small>
                  </div>
                </ng-container>
                <span *ngIf="!rule.dates || !rule.dates.length" class="text-muted">-</span>
              </td>
              <td>
                <ng-container *ngIf="rule.excluded_dates && rule.excluded_dates.length">
                  <div *ngFor="let date of rule.excluded_dates">
                    {{ date.date | date:'EE' }} {{ date.date | date:'mediumDate' }}
                    <small *ngIf="date.notes" class="text-muted">({{ date | translateField: 'notes' }})</small>
                  </div>
                </ng-container>
                <span *ngIf="!rule.excluded_dates || !rule.excluded_dates.length" class="text-muted">-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-12" *ngIf="selectedRuleset && (!selectedRuleset.rules || !selectedRuleset.rules.length)">
      <div class="alert alert-info" i18n>No rules defined in this ruleset.</div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>
